import 'normalize.css'
import './src/index.css'

import React from 'react'
import DietIDApp from './src/App'
import Bugsnag from './src/components/Bugsnag'

const el = document.getElementById('root')

//console.log('%c Version 2021.02.11.0 ', 'background: rgb(232, 239, 239); color: rgb(28, 98, 98)')

const App = () => (
  <Bugsnag>
    <DietIDApp partnerCode={el.getAttribute('partnerCode')} partnerUserId={el.getAttribute('partnerUserId')} />
  </Bugsnag>
)

export default App
